export interface PrivacyPolicy {
  enabled: boolean
  text_prefix: string
  link_text: string
  text_suffix: string
  content_type: 'url' | 'markdown'
  markdown_content: string
  page_url: string
  popup_title: string
}

export interface WidgetFeatures {
  greeting_overlays: boolean
  notification_badge: boolean
  expanded_mode: boolean
  timestamps: boolean
  scroll_to_bottom_button: boolean
  sound_effects: boolean
  tab_title_notifications: boolean
  inactivity_nudge: boolean
  input_toolbar: boolean
  attachments: boolean
  emoji_picker: boolean
  mic_input: boolean
  new_message_divider: boolean
}

export interface WidgetConfiguration {
  // Identity
  chat_id: string  // Chat assistant ID (required by vanilla widget)
  shared_id: string
  authentication_token: string
  
  // Basic Settings
  chat_title: string
  assistant_name: string
  assistant_subtitle: string
  
  // Colors
  header_color: string
  chat_button_color: string
  send_button_color: string
  assistant_chat_bubble_color: string
  assistant_chat_font_color: string
  profile_chat_bubble_color: string
  profile_chat_font_color: string
  
  // Avatars
  show_avatar: boolean
  assistant_avatar_url: string
  user_avatar_url: string
  profile_icon_url: string
  
  // Privacy Policy
  privacy_policy: PrivacyPolicy
  
  // Features
  features: WidgetFeatures
  
  // Technical
  agent: boolean
  api_url: string
  feedback_api_url: string
  proxy_url: string
}

export interface WidgetSettings {
  id: string
  chat_assistant: string
  header_subtitle: string
  privacy_policy_enabled: boolean
  privacy_policy_text_prefix: string
  privacy_policy_link_text: string
  privacy_policy_text_suffix: string
  privacy_policy_page_url: string
}

export interface ChatAssistant {
  id: string
  name: string
  ragflow_chat_id: string
  shared_id: string
  authentication_token: string
  
  // Widget appearance
  header_color: string
  chat_title: string
  chat_title_color: string
  assistant_chat_bubble_color: string
  assistant_chat_font_color: string
  profile_chat_bubble_color: string
  profile_chat_font_color: string
  widget_button_color: string
  
  // Avatar settings
  show_avatar: boolean
  assistant_avatar_url: string
  user_avatar_url: string
  profile_icon_url: string
  
  // Behavior
  agent: boolean
  
  // Related models
  widget_settings?: WidgetSettings
}

export const DEFAULT_WIDGET_CONFIG: Partial<WidgetConfiguration> = {
  chat_title: 'Assistant',
  assistant_name: 'Assistant',
  assistant_subtitle: 'The team can also help',
  
  header_color: '#7A6F9B',
  chat_button_color: '#685155',
  send_button_color: '#7A6F9B',
  assistant_chat_bubble_color: '#D4CDF4',
  assistant_chat_font_color: '#000000',
  profile_chat_bubble_color: '#8B85C1',
  profile_chat_font_color: '#ffffff',
  
  show_avatar: true,
  assistant_avatar_url: 'https://yodel-chat-widget.s3.us-east-1.amazonaws.com/assets/park-ranger.png',
  user_avatar_url: 'https://yodel-chat-widget.s3.us-east-1.amazonaws.com/assets/user.png',
  profile_icon_url: 'https://yodel-chat-widget.s3.us-east-1.amazonaws.com/assets/park-ranger.png',
  
  privacy_policy: {
    enabled: false,
    text_prefix: 'By chatting, you agree to our',
    link_text: 'privacy policy',
    text_suffix: '.',
    content_type: 'url',
    markdown_content: '',
    page_url: '',
    popup_title: 'Privacy Policy',
  },
  
  features: {
    greeting_overlays: true,
    notification_badge: true,
    expanded_mode: false,
    timestamps: true,
    scroll_to_bottom_button: true,
    sound_effects: false,
    tab_title_notifications: true,
    inactivity_nudge: true,
    input_toolbar: true,
    attachments: true,
    emoji_picker: true,
    mic_input: false,
    new_message_divider: true,
  },
  
  agent: false,
}
